var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeloEvry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 8,
    fill: "#232156"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0087 6.98952L14.3413 7.15885C14.4821 7.23063 14.6506 7.23063 14.7914 7.15885L19.2798 4.8757C19.6171 4.70433 20.0202 4.70433 20.3575 4.8757L24.8882 7.1635C25.0283 7.23431 25.1954 7.23431 25.3355 7.1635L25.6748 6.98952C25.7542 6.9491 25.8039 6.86959 25.8039 6.78297C25.8039 6.69635 25.7542 6.61685 25.6748 6.57643L20.3556 3.89416C20.0183 3.72278 19.6151 3.72278 19.2778 3.89416L14.0087 6.57922C13.9308 6.6201 13.8823 6.69881 13.8823 6.78437C13.8823 6.86993 13.9308 6.94864 14.0087 6.98952Z",
    fill: "url(#paint0_linear_679_37777)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4169 10.7649L24.8885 8.39794C25.0301 8.32493 25.1985 8.32674 25.3384 8.40277L25.6747 8.57949C25.7541 8.62115 25.8039 8.70356 25.8039 8.7934C25.8039 8.88324 25.7541 8.96564 25.6747 9.0073L20.4188 11.7876C20.0817 11.9655 19.6787 11.9655 19.3416 11.7876L14.0115 8.98992C13.9321 8.94826 13.8823 8.86585 13.8823 8.77601C13.8823 8.68617 13.9321 8.60377 14.0115 8.56211L19.2674 5.7799C19.6045 5.60201 20.0075 5.60201 20.3446 5.7799L23.7342 7.55294C23.8136 7.5949 23.8632 7.67742 23.8632 7.76733C23.8632 7.85724 23.8136 7.93976 23.7342 7.98172L20.362 9.748C20.0246 9.92623 19.6212 9.92623 19.2838 9.748L16.7151 8.38732C16.5741 8.31246 16.4052 8.31246 16.2642 8.38732L15.9414 8.55825C15.8621 8.6002 15.8124 8.68272 15.8124 8.77263C15.8124 8.86254 15.8621 8.94507 15.9414 8.98702L19.3397 10.7649C19.6768 10.9428 20.0797 10.9428 20.4169 10.7649ZM19.278 6.80334L17.8636 7.55176C17.7847 7.59359 17.7354 7.67572 17.7354 7.76518C17.7354 7.85465 17.7847 7.93678 17.8636 7.97861L19.2867 8.73476C19.6238 8.91264 20.0268 8.91264 20.3639 8.73476L21.7947 7.98633C21.8741 7.94467 21.9239 7.86227 21.9239 7.77243C21.9239 7.68259 21.8741 7.60018 21.7947 7.55852L20.3552 6.80334C20.0181 6.62545 19.6152 6.62545 19.278 6.80334Z",
    fill: "url(#paint1_linear_679_37777)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#E12E56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4527 8.46142C10.5979 8.46142 9.90532 7.70393 9.90532 6.76899C9.90532 5.83434 10.5979 5.07685 11.4527 5.07685C12.3071 5.07685 13 5.83434 13 6.76899C13 7.70393 12.3071 8.4617 11.4527 8.4617V8.46142ZM7.35569 11.506L3.9621 7.87885C3.34597 7.2201 3.34597 6.15228 3.9621 5.49382C4.25502 5.17812 4.65739 5 5.07763 5C5.49788 5 5.90025 5.17812 6.19317 5.49382L9.58702 9.12129C10.2032 9.77976 10.2032 10.8479 9.58702 11.506C9.2941 11.8218 8.89167 12 8.47136 12C8.05104 12 7.64861 11.8218 7.35569 11.506Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_679_37777",
    x1: 13.8805,
    y1: 7.21646,
    x2: 25.804,
    y2: 7.21646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#71CFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AC440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_679_37777",
    x1: 13.8824,
    y1: 11.9193,
    x2: 25.8029,
    y2: 11.9193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#71CFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AC440"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeloEvry);
export default __webpack_public_path__ + "static/media/velo-evry.246a76611abc539c803ce711a618ad41.svg";
export { ForwardRef as ReactComponent };